<!--suppress ALL -->

<template>

  <el-dialog top="10px" title="设置快捷菜单" :visible.sync="isVisible" width="80%" :close-on-click-modal="false"
             :close-on-press-escape="false" :fullscreen="true">
    <el-form :model="form" ref="form" label-width="100px">
      <div>
        <el-form-item>
          <el-checkbox-group v-model="select_ids">
            <div v-for="(f,groupIndex) in menus">
              <div v-if="f.link != 'home'">
                <span>{{ f.name }}</span>
                <el-checkbox v-for="(item,index) in f.children" :key="groupIndex+':'+index" :label="item.id">
                  {{ item.name }}
                </el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button class="btn" @click="onSubmit">确 定</el-button>
        <el-button @click="isVisible = false">关闭</el-button>
      </div>
  </el-dialog>
</template>


<script>

export default {
  name: 'CustomMenu',
  data() {
    return {
      form: {},
      menus: [],
      select_ids: [],
      dialogTitle: '',
      isVisible: false,
      form: {
        functions: [],
        role_id: 0
      },
    }
  },

  methods: {
    init: function () {
      //this.form = {};
      this.isVisible = true;
      this.getMenus();
    },
    onSubmit: function () {
      console.log(this.select_ids)
      let t = this;
      this.$post(
        {
          context: t,
          path: '/user/custom_menu/update/',
          params: {
            menu_ids: this.select_ids.join(',') || ''
          },
          success: function (data) {
            t.isVisible = false;
            window.location.reload();
          }
        })
    },


    getMenus: function () {
      let t = this;
      this.$get(
        {
          context: t,
          path: '/function/menu/pc/',
          params: {},
          success: function (data) {
            //console.log(data.menus);
            t.menus = data.menus;
            t.select_ids = data.customMenuIds
          }
        }
      )
    },

  }

}
</script>
<style scoped >
@import '../../assets/global.css';
</style>

